import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=c1b10d10"
import script from "./Panorama.vue?vue&type=script&lang=js"
export * from "./Panorama.vue?vue&type=script&lang=js"
import style0 from "./Panorama.vue?vue&type=style&index=0&id=c1b10d10&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports